import React, { useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { OrbitControls, useTexture } from '@react-three/drei';
import * as THREE from 'three';

const Mars = () => {
  const meshRef = useRef<THREE.Mesh>(null);
  const colorMap = useTexture('/textures/mars.jpg');

  useFrame((state, delta) => {
    if (meshRef.current) {
      meshRef.current.rotation.y += 0.003;
    }
  });

  return (
    <mesh ref={meshRef}>
      <sphereGeometry args={[2, 64, 64]} />
      <meshStandardMaterial map={colorMap} roughness={0.8} metalness={0.1} />
    </mesh>
  );
};

export const MarsGlobe: React.FC<{ width?: number | string; height?: number | string }> = ({ width = '100%', height = 400 }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width, background: '#0F172A', padding: '16px', borderRadius: '12px', color: 'white' }}>
      <div style={{ width: '100%', height: Number(height) - 40, borderRadius: '8px', overflow: 'hidden' }}>
        <Canvas camera={{ position: [0, 0, 5], fov: 45 }}>
          {/* Dim ambient light so the dark side stays dark */}
          <ambientLight intensity={0.1} />
          {/* Sun-like point light from the left */}
          <pointLight position={[-5, 0, 2]} intensity={20} color="#FFF5E6" decay={2} distance={20} />
          <Mars />
          <OrbitControls enableZoom={true} enablePan={false} />
        </Canvas>
      </div>
      <div style={{ marginTop: '12px', fontSize: '14px', color: '#94A3B8' }}>
        Drag to spin • Scroll to zoom
      </div>
    </div>
  );
};
